import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import Icon from './Icon';
import InputMask from 'react-input-mask';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

const DatePickerInput = forwardRef(({ value, onClick, onChange }, ref) => {
  
  return (
    <div className="flex w-full border-gray-300 rounded">
      <InputMask
        placeholder='--/--/----'
        maskChar=' '
        mask='99/99/9999' 
        ref={ref} 
        value={value} onChange={onChange} className="!border-0 !rounded-none !rounded-l flex-grow"/>
      <button type="button" className="inline-flex items-center justify-center w-12 h-10  bg-gray-300 rounded-r" onClick={onClick}><Icon.Calendar /></button>
    </div>
  )
})

const DatePicker = ({ onChange, name, value, ...rest }) => {
  
  const onChangeSelected = e => {

    onChange({
      target: {
        name,
        value: moment(e).isValid() ? moment(e).format('YYYY-MM-DD') : ''
      }
    })
  }

  const selected = value && moment(value)._d 

  return (
    <ReactDatePicker 
      onChange={onChangeSelected}
      selected={selected}
      customInput={<DatePickerInput />}
      {...rest}
    />
  )
}

DatePicker.defaultProps = {
  value: '',
  name: ''
}

DatePicker.propTypes = {
  value: PropTypes.string, 
  name: PropTypes.string,
  onChange: PropTypes.instanceOf(Function).isRequired
}

export default DatePicker